import React, { useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import { SyncOutlined, CheckCircleFilled } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import  "./savingStatus.css";

const SavingStatus = () => {
    const savingData = useSelector((state) => state.slide.savingData);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className={'SavedData-Conatiner'}>
            {savingData && (
                <>
                    {savingData.isSaving === 'Saving...' ? (
                        // Show "Saving..." icon and text
                        <>
                            <SyncOutlined spin style={{ fontSize: '13px', color: '#6b7280' }} />
                            <span>{savingData.isSaving}</span>
                        </>
                    ) : savingData.isSaving === 'Saved' ? (
                        isSmallScreen ? (
                            // Show tooltip on smaller screens
                            <Tooltip
                                title={
                                    savingData.lastSavedDateTime
                                        ? `${savingData.lastSavedDateTime}, ${savingData.fileSize}`
                                        : savingData.fileSize
                                }
                            >
                                <CheckCircleFilled
                                    style={{ fontSize: '14px', color: '#22c55e', cursor: 'pointer' }}
                                />
                            </Tooltip>
                        ) : (
                            // Show details directly in the header on larger screens
                            <>
                                <CheckCircleFilled style={{ fontSize: '14px', color: '#22c55e' }} />
                                <span>
                                    {savingData.lastSavedDateTime}
                                    {`, ${savingData.fileSize}`}
                                </span>
                            </>
                        )
                    ) : (
                        // If neither "Saving..." nor "Saved" and fileSize exists, show only the file size
                        savingData.fileSize && <span>{savingData.fileSize}</span>
                    )}
                </>
            )}
        </div>
    );
};

export default SavingStatus;
